import React from 'react';

export default ({ data }) => {
    return (
        <div>
            <div className="dashboard-count">{data}</div>
            <div className="dashboard-title">Tasks Due</div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/dashboard/tasks-due.js